import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisOptions, defaultChartOrTableHeight, workspaceCreatedAndCooperationSortList, workspaceTagSortList } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import _ from 'lodash';
import { CompanyDataAnalysisDataSet, CompanyDataAnalysisEventKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import { pVuVColor } from './echartsOption';
let CompanyWorkspaceDataAnalysisService = class CompanyWorkspaceDataAnalysisService {
    constructor(companyDataAnalysisService, companyDataAnalysisApi, i18n) {
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.i18n = i18n;
        /**
         * loggedOption
         */
        this.loggedOption = new CompanyDataAnalysisOptions();
        this.shareOption = new CompanyDataAnalysisOptions();
        this.newWorkspaceOption = new CompanyDataAnalysisOptions();
        this.cooperationOption = new CompanyDataAnalysisOptions();
        this.taggingPvOption = new CompanyDataAnalysisOptions();
        this.taggingUvOption = new CompanyDataAnalysisOptions();
        this.loggedConfigInit();
        this.shareConfigInit();
        this.taggingPvConfigInit();
        this.taggingUvConfigInit();
        // 24.7 由于数据问题 暂时不上
        this.companyDataAnalysisService.isOnline && this.newWorkspaceConfigInit();
        this.companyDataAnalysisService.isOnline && this.cooperationConfigInit();
    }
    loggedConfigInit() {
        this.loggedOption.reportName = CompanyDataAnalysisKeyType.WORKSPACE_LOGIN;
        this.loggedOption.title = this.i18n.t('backoffice.company.dataAnalysis.loggedWorkspace');
        this.loggedOption.canCollapse = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.loginPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.loginUv'),
        };
        this.loggedOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.loggedOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.loggedOption.chartId = 'loggedAnalysis';
        this.loggedOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getLoggedData(params) {
        this.loggedOption.loading = true;
        const concurrencyParams = _.cloneDeep(params);
        concurrencyParams.report_name = this.loggedOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(concurrencyParams).then(data => {
            this.loggedOption.Updated = data.data_date;
            this.loggedOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: CompanyDataAnalysisEventKey.LOGIN,
            };
            this.loggedOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.loggedOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.LOGIN);
            const optionParams = {
                data: data.data_detail,
                total_count: this.loggedOption.statistics[0].label,
                user_count: this.loggedOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.LOGIN,
            };
            this.loggedOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.loggedOption.noData = true;
        }).finally(() => {
            this.loggedOption.loading = false;
        });
    }
    shareConfigInit() {
        this.shareOption.reportName = CompanyDataAnalysisKeyType.WORKSPACE_SHARE;
        this.shareOption.title = this.i18n.t('backoffice.company.dataAnalysis.share');
        this.shareOption.canCollapse = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.sharePv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.shareUv'),
        };
        this.shareOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.shareOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.shareOption.chartId = 'shareAnalysis';
        this.shareOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getShareData(params) {
        const searchParams = _.cloneDeep(params);
        this.shareOption.loading = true;
        searchParams.report_name = this.shareOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(searchParams).then(data => {
            this.shareOption.Updated = data.data_date;
            this.shareOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: CompanyDataAnalysisEventKey.SHARE,
            };
            this.shareOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.shareOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.SHARE);
            const optionParams = {
                data: data.data_detail,
                total_count: this.shareOption.statistics[0].label,
                user_count: this.shareOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.SHARE,
            };
            this.shareOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.shareOption.noData = true;
        }).finally(() => {
            this.shareOption.loading = false;
        });
    }
    newWorkspaceConfigInit() {
        this.newWorkspaceOption.reportName = CompanyDataAnalysisKeyType.WORKSPACE_CREATED;
        this.newWorkspaceOption.title = this.i18n.t('backoffice.company.dataAnalysis.newWorkspace');
        this.newWorkspaceOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.newWorkspaceOption.canChangeViewType = true;
        this.newWorkspaceOption.canCollapse = false;
        this.newWorkspaceOption.statistics = [];
        this.newWorkspaceOption.tableOptions.columns = this.companyDataAnalysisService.getNewWorkspaceTableColumns();
        this.newWorkspaceOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newWorkspaceOption.chartId = 'newWorkspaceAnalysis';
        this.newWorkspaceOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getNewWorkspaceData(params) {
        this.newWorkspaceOption.loading = true;
        const newWorkspaceParams = _.cloneDeep(params);
        newWorkspaceParams.report_name = this.newWorkspaceOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newWorkspaceParams).then((data) => {
            this.newWorkspaceOption.Updated = data.data_date;
            this.newWorkspaceOption.noData = data.data_detail.length === 0;
            if (this.newWorkspaceOption.noData)
                return;
            const params = {
                data,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                sortList: workspaceCreatedAndCooperationSortList,
                colorList: pVuVColor,
                columns: this.companyDataAnalysisService.getNewWorkspaceTableColumns(),
            };
            this.newWorkspaceOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption(params);
            this.newWorkspaceOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
        }).catch(() => {
            this.newWorkspaceOption.noData = true;
        }).finally(() => {
            this.newWorkspaceOption.loading = false;
        });
    }
    cooperationConfigInit() {
        this.cooperationOption.reportName = CompanyDataAnalysisKeyType.WORKSPACE_COOPERATION;
        this.cooperationOption.title = this.i18n.t('backoffice.company.dataAnalysis.cooperation');
        this.cooperationOption.tips = [{
                desc: this.i18n.t('backoffice.company.dataAnalysis.cooperationTips'),
            }];
        this.cooperationOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.cooperationOption.canChangeViewType = true;
        this.cooperationOption.canCollapse = false;
        this.cooperationOption.statistics = [];
        this.cooperationOption.tableOptions.columns = this.companyDataAnalysisService.getNewWorkspaceTableColumns();
        this.cooperationOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.cooperationOption.chartId = 'cooperationAnalysis';
        this.cooperationOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getCooperationWorkspaceData(params) {
        this.cooperationOption.loading = true;
        const newWorkspaceParams = _.cloneDeep(params);
        newWorkspaceParams.report_name = this.cooperationOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newWorkspaceParams).then((data) => {
            this.cooperationOption.Updated = data.data_date;
            this.cooperationOption.noData = data.data_detail.length === 0;
            if (this.cooperationOption.noData)
                return;
            const params = {
                data,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                sortList: workspaceCreatedAndCooperationSortList,
                colorList: pVuVColor,
                columns: this.companyDataAnalysisService.getNewWorkspaceTableColumns(),
            };
            this.cooperationOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption(params);
            this.cooperationOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
        }).catch(() => {
            this.cooperationOption.noData = true;
        }).finally(() => {
            this.cooperationOption.loading = false;
        });
    }
    taggingPvConfigInit() {
        this.taggingPvOption.reportName = CompanyDataAnalysisKeyType.WORKSPACE_TAG;
        this.taggingPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.taggingPv');
        this.taggingPvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.taggingPvOption.canChangeViewType = true;
        this.taggingPvOption.canCollapse = false;
        this.taggingPvOption.statistics = [];
        this.taggingPvOption.tableOptions.columns = this.companyDataAnalysisService.getWorkspaceTagTableColumns();
        this.taggingPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.taggingPvOption.chartId = 'taggingPv';
        this.taggingPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    taggingUvConfigInit() {
        this.taggingUvOption.reportName = CompanyDataAnalysisKeyType.WORKSPACE_TAG;
        this.taggingUvOption.title = this.i18n.t('backoffice.company.dataAnalysis.taggingUv');
        this.taggingUvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.taggingUvOption.canChangeViewType = true;
        this.taggingUvOption.canCollapse = false;
        this.taggingUvOption.statistics = [];
        this.taggingUvOption.tableOptions.columns = this.companyDataAnalysisService.getWorkspaceTagTableColumns();
        this.taggingUvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.taggingUvOption.chartId = 'taggingUv';
        this.taggingUvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getTaggingPvUvData(params) {
        this.taggingPvOption.loading = true;
        this.taggingUvOption.loading = true;
        const pvParams = _.cloneDeep(params);
        pvParams.report_name = this.taggingPvOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(pvParams).then((data) => {
            this.taggingPvOption.Updated = data.data_date;
            this.taggingUvOption.Updated = data.data_date;
            this.taggingPvOption.noData = data.data_detail.length === 0;
            this.taggingUvOption.noData = data.data_detail.length === 0;
            if (this.taggingPvOption.noData)
                return;
            this.taggingPvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
            this.taggingUvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.USER_COUNT);
            this.taggingPvOption.chartOption = this.companyDataAnalysisService.getLineChartOption({
                data,
                sortList: workspaceTagSortList,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                columns: this.companyDataAnalysisService.getWorkspaceTagTableColumns(),
            });
            this.taggingUvOption.chartOption = this.companyDataAnalysisService.getLineChartOption({
                data,
                sortList: workspaceTagSortList,
                dataSet: CompanyDataAnalysisDataSet.USER_COUNT,
                columns: this.companyDataAnalysisService.getWorkspaceTagTableColumns(),
            });
        }).catch(() => {
            this.taggingPvOption.noData = true;
            this.taggingUvOption.noData = true;
        }).finally(() => {
            this.taggingPvOption.loading = false;
            this.taggingUvOption.loading = false;
        });
    }
    initData(params) {
        Promise.all([
            this.getLoggedData(params),
            this.getShareData(params),
            this.getTaggingPvUvData(params),
            // 24.7 由于数据问题 暂时不上
            this.companyDataAnalysisService.isOnline && this.getNewWorkspaceData(params),
            this.companyDataAnalysisService.isOnline && this.getCooperationWorkspaceData(params)
        ]);
    }
};
CompanyWorkspaceDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisService)),
    __param(1, inject(Symbols.CompanyDataAnalysisApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyWorkspaceDataAnalysisService);
export { CompanyWorkspaceDataAnalysisService };
